// extracted by mini-css-extract-plugin
module.exports = {"newsIcon":"NewsIcon_newsIcon__OpvY1"};